import FlooringVariationTableFilter from "./flooring-variation-table-filter";

export default FlooringVariationTableFilter;
